// src/admin/Users.jsx
import React, { useState } from "react";
import { Table, Tag, Button, Input, Space, Modal, Descriptions } from "antd";
import { SearchOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { INITIAL_USERS, INITIAL_BOOKINGS } from "../data/store";

const Users = () => {
  const [data,       setData]       = useState(INITIAL_USERS);
  const [search,     setSearch]     = useState("");
  const [viewUser,   setViewUser]   = useState(null);

  const getUserBookings = (name) =>
    INITIAL_BOOKINGS.filter(b => b.user === name);

  const filtered = data.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.phone.includes(search) ||
    u.city.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    {
      title:"#", key:"idx",
      render:(_,__,i)=><span style={{ color:"#9ca3af", fontWeight:600 }}>{i+1}</span>,
      width:44,
    },
    {
      title:"User", key:"user",
      render: r => (
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:36,height:36,borderRadius:"50%",background:"linear-gradient(135deg,#f5c518,#d4a80f)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#1a1a2e",fontSize:14,flexShrink:0 }}>{r.name[0]}</div>
          <div>
            <div style={{ fontWeight:700,color:"#1a1a2e" }}>{r.name}</div>
            <div style={{ fontSize:12,color:"#9ca3af" }}>{r.email}</div>
          </div>
        </div>
      ),
    },
    { title:"Phone", dataIndex:"phone", key:"phone" },
    { title:"City",  dataIndex:"city",  key:"city"  },
    {
      title:"Bookings", dataIndex:"bookings", key:"bookings",
      render: b => <span style={{ fontWeight:700, color:"#3b82f6" }}>{b}</span>,
      sorter:(a,b)=>a.bookings-b.bookings,
    },
    { title:"Joined", dataIndex:"joined", key:"joined" },
    {
      title:"Status", dataIndex:"status", key:"status",
      render: s => <Tag color={s==="Active"?"green":"red"}>{s}</Tag>,
      filters:[{text:"Active",value:"Active"},{text:"Inactive",value:"Inactive"}],
      onFilter:(v,r)=>r.status===v,
    },
    {
      title:"Action", key:"action",
      render: record => (
        <Space>
          <Button size="small" icon={<EyeOutlined />}    onClick={()=>setViewUser(record)}>View</Button>
          <Button danger size="small" icon={<DeleteOutlined />} onClick={()=>setData(d=>d.filter(u=>u.key!==record.key))}>Delete</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h2 style={{ fontSize:22,fontWeight:800,color:"#1a1a2e",margin:0 }}>Users</h2>
          <p style={{ color:"#9ca3af",fontSize:13,marginTop:2 }}>
            {data.filter(u=>u.status==="Active").length} active · {data.length} total registered
          </p>
        </div>
        <Input
          prefix={<SearchOutlined style={{ color:"#9ca3af" }} />}
          placeholder="Search by name, phone or city…"
          value={search} onChange={e=>setSearch(e.target.value)}
          style={{ width:260,borderRadius:8 }} allowClear
        />
      </div>

      <Table
        dataSource={filtered} columns={columns} rowKey="key"
        scroll={{ x:true }} pagination={{ pageSize:8 }}
        style={{ background:"#fff",borderRadius:16,overflow:"hidden" }}
      />

      {/* View user modal */}
      <Modal
        title={<span style={{ fontWeight:700 }}>👤 User Profile</span>}
        open={!!viewUser} onCancel={()=>setViewUser(null)} footer={null} width={520}
      >
        {viewUser && (
          <div style={{ marginTop:16 }}>
            {/* Avatar */}
            <div style={{ textAlign:"center",marginBottom:20 }}>
              <div style={{ width:64,height:64,borderRadius:"50%",background:"linear-gradient(135deg,#f5c518,#d4a80f)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,fontWeight:800,color:"#1a1a2e",margin:"0 auto 10px" }}>{viewUser.name[0]}</div>
              <div style={{ fontWeight:800,fontSize:18,color:"#1a1a2e" }}>{viewUser.name}</div>
              <Tag color={viewUser.status==="Active"?"green":"red"} style={{ marginTop:6 }}>{viewUser.status}</Tag>
            </div>

            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label="Phone">{viewUser.phone}</Descriptions.Item>
              <Descriptions.Item label="Email">{viewUser.email}</Descriptions.Item>
              <Descriptions.Item label="City">{viewUser.city}</Descriptions.Item>
              <Descriptions.Item label="Total Bookings"><b style={{ color:"#3b82f6" }}>{viewUser.bookings}</b></Descriptions.Item>
              <Descriptions.Item label="Joined">{viewUser.joined}</Descriptions.Item>
            </Descriptions>

            {/* User's booking history */}
            {getUserBookings(viewUser.name).length > 0 && (
              <div style={{ marginTop:20 }}>
                <p style={{ fontWeight:700,color:"#1a1a2e",marginBottom:10 }}>Booking History</p>
                {getUserBookings(viewUser.name).map(b=>(
                  <div key={b.key} style={{ background:"#f8f9fd",borderRadius:10,padding:"10px 14px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8 }}>
                    <div>
                      <div style={{ fontWeight:600,fontSize:13 }}>{b.route}</div>
                      <div style={{ fontSize:12,color:"#9ca3af" }}>{b.date} · {b.driver}</div>
                    </div>
                    <div style={{ display:"flex",gap:8,alignItems:"center" }}>
                      <b style={{ color:"#d4a80f" }}>₹{b.price.toLocaleString()}</b>
                      <Tag color={{ Pending:"orange",Approved:"blue",Ongoing:"cyan",Completed:"green",Cancelled:"red" }[b.status]}>{b.status}</Tag>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Users;